<template>
  <div class="flex items-center space-x-1">
    <button
      v-for="star in maxStars"
      :key="star"
      @click.prevent="setRating(star)"
      @mouseover="hoverRating = star"
      @mouseleave="hoverRating = 0"
      class="text-3xl text-gray-300 transition-colors"
      :class="{ 'text-red-400': (hoverRating || value) >= star }"
      :aria-label="'Rate ' + star + ' out of ' + maxStars + ' stars'"
    >
      &#9733;
    </button>
  </div>
</template>
<script>
export default {
  name: "StarRating",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    maxStars: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      hoverRating: 0,
    };
  },
  methods: {
    setRating(rating) {
      this.$emit("input", rating);
    },
  },
};
</script>
